import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function RiskCoverIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53187 1.50889L3.53183 3.0089C3.01143 3.20405 2.66667 3.70143 2.66667 4.25723V8C2.66668 10.3724 6.00188 12.7447 7.3974 13.6335C7.77073 13.8713 8.23587 13.8824 8.61807 13.6591C10.0226 12.8387 13.3333 10.6263 13.3333 8V4.25723C13.3333 3.70144 12.9886 3.20405 12.4682 3.00889L8.4682 1.50889C8.16633 1.3957 7.83367 1.3957 7.53187 1.50889ZM8.00862 4.25994C8.26861 4.25994 8.47948 4.46295 8.47948 4.71339V4.71819C9.36637 4.80673 10.058 5.52873 10.058 6.40627C10.058 6.65671 9.84718 6.85972 9.58711 6.85972C9.32704 6.85972 9.11624 6.65671 9.11624 6.40627C9.11624 6.03068 8.84419 5.71628 8.47948 5.63588V6.88578C9.35326 6.89733 10.058 7.5831 10.058 8.42737C10.058 9.27164 9.35326 9.95739 8.47941 9.96893C8.47707 10.2175 8.26718 10.4182 8.00862 10.4182C7.74855 10.4182 7.53775 10.2152 7.53775 9.96479V9.93991C6.72078 9.79212 6.1027 9.10152 6.1027 8.2719C6.1027 8.02147 6.3135 7.81845 6.57357 7.81845C6.83364 7.81845 7.04443 8.02147 7.04443 8.2719C7.04443 8.59631 7.2474 8.87506 7.53775 8.99682V7.78436C6.73148 7.70441 6.1027 7.04833 6.1027 6.25081C6.1027 5.45328 6.73148 4.79719 7.53775 4.71725V4.71339C7.53775 4.46295 7.74855 4.25994 8.00862 4.25994ZM7.04443 6.25081C7.04443 5.95539 7.25395 5.7071 7.53775 5.63625V6.86536C7.25395 6.79451 7.04443 6.54622 7.04443 6.25081ZM9.11624 8.42737C9.11624 8.77076 8.83312 9.05046 8.47948 9.06184V7.7929C8.83312 7.80429 9.11624 8.08399 9.11624 8.42737Z"
        fill="currentColor"
      />
    </svg>
  )
}
